import { jsx as _jsx } from "react/jsx-runtime";
import { nonEmptyQuickfacts } from '../../../../_shared/parcel-view/merge';
import QuickFacts from '../../../../general/components/property/quick-facts';
import SidebarPanel from '../../../../general/components/property/sidebar-panel';
import { hasText } from '../../_tour-home';
// The house's key facts in the tile a property's profile gives them, open to start with. Built and
// the address lead, written as the property's own facts are.
const HomeFacts = (props) => {
    var _a, _b;
    const facts = props.lead === null ? [] : nonEmptyQuickfacts(props.lead.quickfacts);
    const established = (_b = (_a = props.lead) === null || _a === void 0 ? void 0 : _a.established) !== null && _b !== void 0 ? _b : '';
    if (facts.length === 0 && !hasText(established))
        return null;
    const rows = nonEmptyQuickfacts([
        { 'name': 'built', 'kind': 'string', 'title': 'Built', 'icon': 'bi bi-calendar3', 'value': established },
        { 'name': 'address', 'kind': 'string', 'title': 'Address', 'icon': 'bi bi-geo-alt', 'value': props.address },
        ...facts,
    ]);
    return (_jsx("div", { className: "tour-home-facts", children: _jsx(SidebarPanel, { icon: "bi bi-info-circle", title: "Quick Facts", collapsible: true, children: _jsx(QuickFacts, { facts: rows }) }) }));
};
export default HomeFacts;
